export default "__VITE_ASSET__CTg4YXJN__"